import { makeAutoObservable } from "mobx";
// History
import historyStore from "./HistoryStore";
// Types
import { Business } from "../types/Business";
import { Supervisor } from "../types/Supervisor";
import { postSupervisor } from "../api/supervisor";
// Routes
import { INITIALIZATION } from "src/constants/routes";
import * as storageUtils from '../utils/localStorage';

class SupervisorStore {
  constructor() {
    makeAutoObservable(this);
  }

  supervisor: Supervisor | null = null;
  business: Business | null = null;
  isLoading = false;
  dobError: string = "";
  testkit = false;

  setSupervisor(supervisor: Supervisor) {
    this.supervisor = supervisor;
  }

  setBusiness(business: Business) {
    this.business = business;
  }

  setSupervisorId(id: string) {
    this.supervisor = { ...this.supervisor!, id: id };
  }

  setDobError(error: string) {
    this.dobError = error;
  }

  saveData(data: Supervisor) {
    postSupervisor({ supervisor: data, business: this.business })
      .then((response: any) => {
        this.isLoading = false;
        this.setSupervisor(response);
        this.setSupervisorId(response.id);
        storageUtils.setSupervisorId(response.id);
        historyStore.navigate(`${INITIALIZATION}?from=registration`);
      })
      .catch((error) => {
        this.isLoading = false;
        if (error && error.response && error.response.data) {
          console.log("Error saving supervisor data", error.response.data);
          const { birthdate } = error.response.data;
          if (birthdate) {
            this.dobError = birthdate[0];
          }
        }
      });
  }
}

const supervisorStore = new SupervisorStore();

export default supervisorStore;
